import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import servicioCfdi from '../servicios/ServicioCfdi'
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import { Lightbox } from 'primereact/lightbox';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import servicioEnvioCorreo from '../servicios/ServicioEnvioCorreo';
import formatoEspanolEsMX from '../servicios/ServicioIdiomaFecha';
import './Iframe.css';
export class DetalleRecibos extends React.Component {
    constructor(props) {
        super(props)
        const { handle } = this.props.match.params;
        const { id } = this.props.location.state;
        
        super(props)
        this.state = {
            fechaInicial: null,
            fechaFinal: null,
            iFrameSrc: null,
            tcTrabajador: {},
            errores: {},
            paginacion: { registrosPorPagina: 20, restricciones:{} },
            inicio: 0,
            cfdis: [],
            criterio: {},
            muestraBoton: 'none',
            nombreTrabajador: {}

        }
        let { tcTrabajador, nombreTrabajador } = this.state;
        tcTrabajador.rfc = id.rfc;
        nombreTrabajador.nombre = id.nombre;
    }
    componentDidMount() {
        // this.obtenerPagina();
    }
    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();

    }
    obtenerPagina() {
        let { paginacion, fechaInicial, fechaFinal, tcTrabajador } = this.state;
        const resultadoValidacion = this.validarFormulario();
        this.setState({ errores: resultadoValidacion });
        let fechas = [
            fechaInicial,
            fechaFinal
        ]
        paginacion['between'] = fechas;
        let nombrePropiedad = "alias_tcTrabajador.rfc";
        
        paginacion.restricciones = {};
        paginacion.restricciones[nombrePropiedad] = tcTrabajador.rfc;
        if (!Object.keys(resultadoValidacion).length) {
            servicioCfdi.paginacionAdmin(paginacion).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

                if (response.data.error === false)
                    this.setState({ paginacion: response.data.objeto, muestraBoton: 'block' });

            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }
    }
    validarFormulario() {
        let { fechaInicial, fechaFinal } = this.state;
        const errores = {};

        if (!fechaInicial)
            errores.fechaInicial = "El campo es requerido";
        if (fechaInicial !== undefined && fechaInicial !== null)
            if (fechaInicial.length > 0 && new Date(fechaInicial).toString() === 'Invalid Date')
                errores.fechaInicial = "Fecha inválida";

        if (!fechaFinal)
            errores.fechaFinal = "El campo es requerido";
        if (fechaFinal !== undefined && fechaFinal !== null)
            if (fechaFinal.length > 0 && new Date(fechaFinal).toString() === 'Invalid Date')
                errores.fechaFinal = "Fecha inválida";
        return errores;
    };
    columnaTotal = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.subtotal)}</div>;
    }
    columnaDescuento = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.descuento)}</div>;
    }

    columnaNeto = (rowData, column) => {
        return <div>
            {servicioFormatos.formatearModena(rowData.total)}
        </div>;
    }

    columnaFechaFinalPago = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaPago)}</div>;
    }
    columnaDescargaXml = (rowData, column) => {
        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                    tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
                </Button>
            </div>
        </div>;
    }
    generaDescarga = (objeto, tipo) => {
        servicioArchivo.descargaArchivo('/cfdi/descarga_comprobante.json?uuid=' + objeto.uuid + '&tipo=' + tipo)
            .then((response) => {
                if (response !== "si")
                    return this.growl.show({ severity: 'error', summary: '', detail: response });
            });
    }
    columnaDescargaPdf = (rowData, column) => {
        return <div>
            <div>
                <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                    tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
                </Button>
            </div>
        </div>;
    }
    columnaVerRecibo = (rowData, column) => {
        return <div>
            <div>
                <Button icon="pi-md-remove-red-eye" type="button" tooltip="Ver recibo" onClick={(e) => this.visorPdf(column.rowData, 'pdf')}></Button>
            </div>
        </div>;
    }
    visorPdf = (objeto, tipo) => {
        servicioArchivo.descargaArchivoComoBlob('/cfdi/descarga_comprobante.json?uuid=' + objeto.uuid + '&tipo=' + tipo)
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });

    }

    asignarValores(event) {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }
    enviarCfdis() {
        let { cfdis, criterio } = this.state;
        let listaEnvio = [];
        if (cfdis.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: "Selecciona al menos un comprobante" });

        const resultadoValidacion = this.validarCorreo(criterio.correo);
        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {

            cfdis.forEach(cfdi => {
                let correo = {};
                correo['correo'] = criterio.correo;
                correo['estatus'] = 0;
                correo['ttCfdi'] = cfdi;
                listaEnvio.push(correo);
            });
            servicioEnvioCorreo.enviar_cfdis_correo(listaEnvio).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.resetEstados();
            }).catch((error) => { });
        }
    }
    validarCorreo(correo) {
        const errores = {};
        let regularCorreo = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        if (!correo)
            errores.correo = "El campo es requerido";

        let correos = correo.split(',');
        correos.forEach(nuevoCorreo => {
            if (!regularCorreo.test(nuevoCorreo))
                errores.correo = "Correo o correos inválidos";
        })

        return errores;
    }
    columnaSeleccionar = (rowData, column) => {
        return <div>
            <div>
                <Checkbox inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)}></Checkbox>
            </div>
        </div>;
    }
    asignarCfdis(e) {
        let { cfdis } = this.state;

        if (e.checked)
            cfdis.push(e.value);
        else
            cfdis.splice(cfdis.indexOf(e.value), 1);

        this.setState({ cfdis });

    }
    render() {
        let { paginacion, inicio, iFrameSrc, muestraBoton, errores, criterio, fechaFinal, fechaInicial, nombreTrabajador } = this.state;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );
        return (<div className="p-grid">
            <Growl ref={(el) => this.growl = el} />
            <Lightbox target={visorPdfTarget}>
                <div id="contenedorIframe"  >
                    <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                </div>
            </Lightbox>


            <div className="p-col-12">
                <div className="card card-w-title">
                    <h1>Recibos de Nómina de: {nombreTrabajador.nombre}</h1>
                    <div className="p-grid">
                    <div className="p-md-10">
                        </div>
                        <div className="p-md-2">
                            <Button className="p-button-Primary p-button-raised" label={<Link className="colorRegresar" to={{
                                pathname: "/consultareciboquadrum/bienvenido/consultarrecibos",
                                state: {}
                            }}>Regresar</Link>}>

                            </Button>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="fechaInicial">* Fecha Inicial</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Calendar locale={formatoEspanolEsMX} id="fechaInicial" name="fechaInicial" className={errores.fechaInicial ? 'p-error' : ''} value={fechaInicial || ''} onChange={(e) => { this.setState({ fechaInicial: e.value }) }} showIcon={true} />
                            {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="fechaPago">* Fecha Final</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Calendar locale={formatoEspanolEsMX} id="fechaFinal" name="fechaFinal" className={errores.fechaFinal ? 'p-error' : ''} value={fechaFinal || ''} onChange={(e) => { this.setState({ fechaFinal: e.value }) }} showIcon={true} />
                            {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                        </div>

                        <div className="p-col-12 p-md-2">
                            <Button className="p-button-Primary p-button-raised" label="Buscar"
                                icon="pi-md-search" tooltip={"Consultar comprobantes"} onClick={this.obtenerPagina.bind(this)} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <div style={{ display: muestraBoton }}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">email</i></span>
                                        <InputText id="correo" name="criterio.correo" className={errores.correo ? 'p-error' : ''}
                                            placeholder="ejemplo@dominio.com" tooltip="Para agregar más de un correo debes separarlo por una coma (,) seguido del nuevo correo "
                                            value={criterio.correo || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-4">
                                    <Button className="p-button-Primary p-button-raised" label="Enviar"
                                        onClick={this.enviarCfdis.bind(this)} icon="pi-md-mail" tooltip="Enviar a mi correo" />
                                </div>

                            </div>
                        </div>
                    </div>

                    <DataTable value={paginacion.datos} selectionMode="single" responsive={true} header="Mis recibos de Nómina" >
                        <Column header="Seleccionar" body={this.columnaSeleccionar} autoLayout={true} />
                        <Column header="Ver Recibo" body={this.columnaVerRecibo} autoLayout={true} />
                        <Column header="Descarga Xml" body={this.columnaDescargaXml} autoLayout={true} />
                        <Column header="Descarga Pdf" body={this.columnaDescargaPdf} autoLayout={true} />
                        <Column field="uuid" header="Uuid" style={{ width: '150px' }} autoLayout={true} />
                        <Column header="Total" body={this.columnaTotal} autoLayout={true} />
                        <Column header="Descuento" body={this.columnaDescuento} autoLayout={true} />
                        <Column header="Neto" body={this.columnaNeto} autoLayout={true} />
                        <Column header="Fecha de Pago" body={this.columnaFechaFinalPago} style={{ width: '150px' }} autoLayout={true} />
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        </div>

        );
    }
}